import { render } from "./FormTrainingItemFields.vue?vue&type=template&id=dbbbf76e&scoped=true&ts=true"
import script from "./FormTrainingItemFields.vue?vue&type=script&lang=ts"
export * from "./FormTrainingItemFields.vue?vue&type=script&lang=ts"

import "./FormTrainingItemFields.vue?vue&type=style&index=0&id=dbbbf76e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbbf76e"]])

export default __exports__